import { useEffect, useRef, useState } from "react";
import dayjs from "dayjs";
import OrderQrModal from "./OrderQrModal";

interface OrderItemData {
    id: number;
    code: string;
    total: number;
    status: number;
    created_at: string;
    order_product: {
        quantity_product: number;
    }[];
}

interface OrderItemProps {
    data: OrderItemData;
}

const STATUS_MAP: Record<number, { label: string; color: string }> = {
    1: { label: "Chờ xác nhận", color: "#FFA500" },
    2: { label: "Đã xác nhận", color: "#1890ff" },
    3: { label: "Đang xử lý", color: "#1890ff" },
    4: { label: "Đang giao", color: "#1890ff" },
    5: { label: "Đã giao", color: "#52c41a" },
    6: { label: "Giao thành công", color: "#52c41a" },
    0: { label: "Đã hủy", color: "#f5222d" },
};

const OrderItem: React.FC<OrderItemProps> = ({ data }) => {
    const [openDocs, setOpenDocs] = useState(false);
    const [openQrModal, setOpenQrModal] = useState(false);
    const dropdownRef = useRef<HTMLDivElement | null>(null);
    const toggleBtnRef = useRef<HTMLSpanElement | null>(null);

    const statusInfo = STATUS_MAP[data.status] || { label: "Không xác định", color: "#000" };
    const totalQuantity = data.order_product?.reduce((acc, item) => acc + item.quantity_product, 0) || 0;
    const productCount = data.order_product?.length || 0;
    const orderDetailPath = `/my-order/${data.id}`;
    const orderDetailUrl = typeof window === "undefined"
        ? orderDetailPath
        : new URL(orderDetailPath, window.location.origin).toString();

    const handleOpenDocs = (e: React.MouseEvent) => {
        e.preventDefault();    // ⛔ chặn href
        e.stopPropagation();   // ⛔ chặn bubble lên <a>

        setOpenDocs((prev) => !prev);
    };

    const handleFeedback = (e: React.MouseEvent) => {
        e.preventDefault();
        e.stopPropagation();
        // TODO: mở modal phản hồi
        console.log("Feedback");
    };

    const handleOpenQrModal = (e: React.MouseEvent<HTMLButtonElement>) => {
        e.preventDefault();
        e.stopPropagation();
        setOpenQrModal(true);
    };

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            const target = event.target as Node;

            // 👉 Click vào nút toggle thì BỎ QUA
            if (toggleBtnRef.current?.contains(target)) {
                return;
            }

            // 👉 Click ra ngoài dropdown thì đóng
            if (
                dropdownRef.current &&
                !dropdownRef.current.contains(target)
            ) {
                setOpenDocs(false);
            }
        };

        if (openDocs) {
            document.addEventListener("mousedown", handleClickOutside);
        }

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [openDocs]);

    return (
        <div
            className="MuiGrid-root MuiGrid-container"
            style={{ position: "relative", zIndex: 0 }}
        >
            <a
                className="styles_mobile_rootBase__8z7PQ styles_w_100__dLF02"
                href={`/my-order/${data.id}`}
            >
                <div className="MuiGrid-root styles_orderInfoCard__3cJhk MuiGrid-item MuiGrid-grid-xs-12">
                    <div className="MuiGrid-root styles_wrapOrderList__3tDef MuiGrid-container">
                        {/* ===== ORDER CODE ===== */}
                        <div
                            className="MuiGrid-root styles_order_code_wrapper__BeZVy MuiGrid-container MuiGrid-item MuiGrid-grid-sm-3 MuiGrid-grid-md-3"
                            style={{ gap: "4px" }}
                        >
                            <p className="MuiTypography-root styles_orderCode__jgr30 MuiTypography-body1">
                                #{data.code} &nbsp;
                            </p>

                            <div className="MuiGrid-root MuiGrid-container MuiGrid-item MuiGrid-align-items-xs-center">
                                <span
                                    style={{
                                        boxSizing: "border-box",
                                        display: "inline-block",
                                        overflow: "hidden",
                                        width: "initial",
                                        height: "initial",
                                        background: "none",
                                        opacity: 1,
                                        border: "0px",
                                        margin: "0px",
                                        padding: "0px",
                                        position: "relative",
                                        maxWidth: "100%",
                                    }}
                                >
                                    <span
                                        style={{
                                            boxSizing: "border-box",
                                            display: "block",
                                            width: "initial",
                                            height: "initial",
                                            background: "none",
                                            opacity: 1,
                                            border: "0px",
                                            margin: "0px",
                                            padding: "0px",
                                            maxWidth: "100%",
                                        }}
                                    >
                                        <img
                                            alt=""
                                            aria-hidden="true"
                                            src="data:image/svg+xml,%3csvg%20xmlns=%27http://www.w3.org/2000/svg%27%20version=%271.1%27%20width=%2712%27%20height=%2712%27/%3e"
                                            style={{
                                                display: "block",
                                                maxWidth: "100%",
                                                width: "initial",
                                                height: "initial",
                                                background: "none",
                                                opacity: 1,
                                                border: "0px",
                                                margin: "0px",
                                                padding: "0px",
                                            }}
                                        />
                                    </span>
                                    <img
                                        src="https://cdn-web-next.thuocsi.vn/orderStatus/time.svg"
                                        style={{
                                            position: "absolute",
                                            inset: "0px",
                                            boxSizing: "border-box",
                                            padding: "0px",
                                            border: "none",
                                            margin: "auto",
                                            display: "block",
                                            width: "0px",
                                            height: "0px",
                                            minWidth: "100%",
                                            maxWidth: "100%",
                                            minHeight: "100%",
                                            maxHeight: "100%",
                                        }}
                                    />
                                </span>

                                <p className="MuiTypography-root styles_timeOrder__9cc2E MuiTypography-body1">
                                    {dayjs(data.created_at).format("HH:mm:ss DD/MM/YYYY")}
                                </p>
                            </div>

                            <p className="MuiTypography-root styles_timeOrder__9cc2E MuiTypography-body1">
                                Không gửi yêu cầu xuất hóa đơn
                            </p>
                        </div>

                        {/* ===== PRICE ===== */}
                        <div
                            className="MuiGrid-root styles_order_code_wrapper__BeZVy MuiGrid-container MuiGrid-item MuiGrid-align-content-xs-flex-start MuiGrid-grid-sm-3 MuiGrid-grid-md-2"
                            style={{ gap: "4px" }}
                        >
                            <p className="MuiTypography-root styles_priceOrder__aWjor MuiTypography-body1">
                                {data.total.toLocaleString()}đ
                            </p>
                            <div className="MuiGrid-root MuiGrid-container MuiGrid-item">
                                <p className="MuiTypography-root styles_quantityOrder__6drdj MuiTypography-body1">
                                    Sản phẩm{" "}
                                    <span className="styles_numberBold__Y_nQc">{productCount}</span> - Tổng SL{" "}
                                    <span className="styles_numberBold__Y_nQc">{totalQuantity}</span>
                                </p>
                            </div>
                        </div>

                        {/* ===== STATUS ===== */}
                        <div
                            className="MuiGrid-root styles_order_time_wrapper___yz3C MuiGrid-container MuiGrid-item MuiGrid-align-content-xs-flex-start MuiGrid-grid-sm-3 MuiGrid-grid-md-4"
                            style={{ gap: "4px" }}
                        >
                            <div
                                className="MuiGrid-root styles_groupBtn__h_kv_ MuiGrid-container MuiGrid-align-items-xs-center MuiGrid-justify-content-xs-flex-end">
                                <div

                                    className="MuiGrid-root styles_statusOrder__E64sW MuiGrid-container ">
                                    <div
                                        className="styles_statusDot__7UkdW MuiBox-root css-0"
                                        style={{ backgroundColor: statusInfo.color }}
                                    ></div>
                                    <p className="MuiTypography-root MuiTypography-body1">
                                        {statusInfo.label}
                                    </p>
                                </div>

                                <div
                                    className="MuiGrid-root styles_deliveryDate__v3TzE MuiGrid-container MuiGrid-item ">
                                    <p className="MuiTypography-root MuiTypography-body1">
                                        Dự kiến giao <span>Thứ bảy (24/01/2026)</span>
                                    </p>
                                </div>
                            </div>
                        </div>

                        {/* ===== ACTION BUTTONS ===== */}
                        <div className="MuiGrid-root styles_order_btn_wrapper__dV_Yy MuiGrid-container MuiGrid-item MuiGrid-grid-md-4">
                            <div className="MuiGrid-root styles_groupBtn__h_kv_ MuiGrid-container MuiGrid-align-items-xs-center MuiGrid-justify-content-xs-flex-end">
                                <button
                                    className="MuiButtonBase-root MuiButton-root MuiButton-text styles_btnAction__2nq8X"
                                    type="button"
                                    onClick={handleOpenQrModal}
                                    style={{
                                        backgroundColor: "#005C29",
                                        color: "#ffffff",
                                        borderRadius: "8px",
                                        padding: "6px 14px",
                                    }}
                                >
                                    <span className="MuiButton-label">
                                        <span>Mã QR</span>
                                    </span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </a>

            <OrderQrModal
                open={openQrModal}
                onClose={() => setOpenQrModal(false)}
                orderCode={data.code}
                detailUrl={orderDetailUrl}
            />
        </div>
    );
};

export default OrderItem;